import { render, staticRenderFns } from "./doc_detail.vue?vue&type=template&id=81b09be0&scoped=true&"
import script from "./doc_detail.vue?vue&type=script&lang=js&"
export * from "./doc_detail.vue?vue&type=script&lang=js&"
import style0 from "./doc_detail.vue?vue&type=style&index=0&id=81b09be0&lang=less&scoped=true&"
import style1 from "./doc_detail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b09be0",
  null
  
)

export default component.exports